import React from 'react';
import { useSmartHedgeStrategy } from '../hooks/useSmartHedgeStrategy';

export const HedgeDetails = ({ hedgeStrategy, perpPosition }) => {
  // Smart strategy only - eliminates all state conflicts
  const { 
    hedgeStrategy: smartStrategy, 
    isCalculating, 
    isTransitioning 
  } = useSmartHedgeStrategy(perpPosition);
  
  // Simple, reliable strategy selection
  const displayStrategy = smartStrategy || hedgeStrategy;

  const formatCurrency = (value) => {
    return `$${Number(value).toLocaleString('en-US', { 
      minimumFractionDigits: 2, 
      maximumFractionDigits: 2 
    })}`;
  };

  if (isCalculating && !displayStrategy) {
    return (
      <div className="bg-atticus-navy-800 rounded-xl p-6 text-center">
        <div className="animate-spin w-8 h-8 border-2 border-purple-500 border-t-transparent rounded-full mx-auto mb-4"></div>
        <div className="text-gray-400">Calculating optimal hedge strategy...</div>
      </div>
    );
  }

  return (
    <div className="bg-atticus-navy-800 rounded-xl p-6">
      <h4 className="text-white font-bold text-lg mb-4">Recommended Hedge</h4>
      
      {displayStrategy && (
        <div className={`transition-all duration-500 ${isTransitioning ? 'opacity-50' : 'opacity-100'}`}>
          <div className="bg-atticus-navy-700 rounded-lg p-4 mb-4">
            <div className="flex items-center justify-between mb-3">
              <span className="text-lg font-bold text-white">
                {displayStrategy.strategy_name}
              </span>
              <span className="px-3 py-1 rounded-full text-sm font-medium bg-green-500/20 text-green-400">
                Smart Strategy
              </span>
            </div>
            <p className="text-gray-400 text-sm">{displayStrategy.description}</p>
          </div>

          <div className="grid grid-cols-2 gap-3">
            <div className="bg-atticus-navy-700 rounded-lg p-3 text-center">
              <div className="text-gray-400 text-xs">Cost</div>
              <div className={`text-red-400 font-bold text-lg transition-all duration-300 ${
                isTransitioning ? 'animate-pulse' : ''
              }`}>
                {formatCurrency(displayStrategy.cost)}
              </div>
              <div className="text-gray-500 text-xs">Debit</div>
            </div>
            
            <div className="bg-atticus-navy-700 rounded-lg p-3 text-center">
              <div className="text-gray-400 text-xs">Protection</div>
              <div className={`text-green-400 font-bold text-lg transition-all duration-300 ${
                isTransitioning ? 'animate-pulse' : ''
              }`}>
                {formatCurrency(Math.abs(displayStrategy.max_protection))}
              </div>
              <div className="text-gray-500 text-xs">Downside covered</div>
            </div>
          </div>

          <div className="mt-4 text-center">
            <div className="text-xs text-blue-400 bg-blue-500/20 rounded-lg p-2">
              ✅ Smart updates with smooth transitions
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
